import { useEffect, useState } from "react"

import { useLazyGetContractorQuery } from "store/api/contractorsApi"
import { ApiTypes } from "types"

export const useContractors = (contractorIds: number[]) => {
  const [getContractor] = useLazyGetContractorQuery()
  const [contractors, setContractors] = useState<ApiTypes.Model.Contractor[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const contractorIdsKey = contractorIds.join(",")

  useEffect(() => {
    let isActive = true
    const ids = contractorIdsKey.split(",").map(Number).filter(Boolean)

    const fetchContractors = async () => {
      setIsLoading(true)

      try {
        const results = await Promise.allSettled(ids.map(contractorId => getContractor(String(contractorId)).unwrap()))

        if (!isActive) return

        setContractors(results.flatMap(result => (result.status === "fulfilled" ? [result.value.data] : [])))
      } finally {
        if (isActive) {
          setIsLoading(false)
        }
      }
    }

    if (ids.length > 0) {
      fetchContractors()
    } else {
      setContractors([])
      setIsLoading(false)
    }

    return () => {
      isActive = false
    }
  }, [contractorIdsKey, getContractor])

  return { contractors, isLoading }
}
